import React, { useState } from 'react';

const WHATSAPP_NUMBER = "5581979163230";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Gostaria de falar sobre um caso trabalhista.`;

const services = [
  {
    icon: "⏰",
    title: "Horas Extras e Jornada",
    description: "Receba o que é seu por direito. Atuamos em casos de horas extras não pagas e jornadas irregulares."
  },
  {
    icon: "📋",
    title: "Trabalho sem Registro",
    description: "Trabalhador sem carteira assinada? Garantimos seus direitos como férias, 13º e FGTS."
  },
  {
    icon: "⚠️",
    title: "Rescisão Irregular",
    description: "Demissão por justa causa indevida ou verbas rescisórias não pagas. Recupere seus direitos."
  },
  {
    icon: "🚫",
    title: "Assédio Moral ou Sexual",
    description: "Proteção e reparação para vítimas de assédio no ambiente de trabalho."
  },
  {
    icon: "🏥",
    title: "Acidente de Trabalho",
    description: "Acidentes ou doenças ocupacionais. Lutamos pela sua indenização e estabilidade."
  },
  {
    icon: "👶",
    title: "Direitos da Gestante",
    description: "Estabilidade, licença-maternidade e proteção integral à trabalhadora grávida."
  }
];

const differentials = [
  { icon: "✓", title: "Avaliação Gratuita", description: "Análise do seu caso sem custo(caso contratar o escritorio" },
  { icon: "🛡️", title: "Só Paga ao fim do processo", description: "Sem risco financeiro para você" },
  { icon: "💬", title: "Atendimento Direto", description: "Fale diretamente com Dr Carlos" },
  { icon: "📍", title: "Atuação Nacional", description: "Atendemos em todo o Brasil" }
];

const faqs = [
  {
    question: "Como funciona o atendimento online?",
    answer: "Nosso atendimento online é simples, seguro e totalmente voltado para a sua comodidade. Você pode agendar uma consulta pelo nosso site, telefone ou WhatsApp. No dia e horário marcados, realizamos a reunião por vídeo chamada, onde você poderá explicar seu caso com total privacidade. Durante o atendimento, nossos advogados esclarecem dúvidas, orientam sobre os procedimentos e explicam os documentos necessários para dar andamento ao seu processo. Após a reunião, todo o acompanhamento pode ser feito de forma digital: troca de documentos, assinatura de procurações e notificações sobre o andamento do processo, garantindo que você tenha suporte completo sem sair de casa. Caso prefira, também atendemos presencialmente em nosso escritório em Recife."


  },
  {
    question: "Qual o prazo para entrar com uma ação trabalhista?",
    answer: "O prazo para ajuizar uma ação trabalhista é determinado pelo art. 7º, XXIX, da Constituição Federal e pelos arts. 11 e 442 da CLT. Em regra, o trabalhador possui até 2 anos após o término do contrato de trabalho para ingressar com a reclamação, podendo reivindicar direitos relativos aos últimos 5 anos de prestação de serviços."
  },
  {
    question: "Quanto posso receber em uma ação trabalhista?",
    answer: "O valor que você pode receber em uma ação trabalhista depende de diversos fatores, como o tipo de direito reclamado (horas extras, férias, 13º salário, verbas rescisórias, adicionais, indenizações, entre outros), o tempo de serviço e o histórico salarial. Não existe um valor fixo, pois cada caso é analisado individualmente. No nosso escritório, fazemos uma análise detalhada do seu contrato de trabalho, holerites e demais documentos, para calcular de forma precisa o montante que você tem direito a receber. Além disso, avaliamos estratégias jurídicas para maximizar a recuperação de seus direitos, sempre dentro da legislação vigente. Oferecemos esse atendimento tanto presencial em Recife quanto online, garantindo agilidade e segurança durante todo o processo."
  },
  {
    question: "Em quais casos posso entrar com uma ação trabalhista?",
    answer: "Você pode ingressar com uma ação trabalhista sempre que houver descumprimento de direitos previstos na Consolidação das Leis do Trabalho (CLT) ou na Constituição Federal, relacionados à relação de emprego. Entre os casos mais comuns estão: Verbas rescisórias não pagas (como saldo de salário, férias, 13º salário);Horas extras não remuneradas ou banco de horas irregular; Equiparação salarial ou diferenças salariais; Descontos indevidos no salário; Assédio moral ou demissão discriminatória; Acidentes de trabalho ou problemas relacionados à segurança do trabalho."
  },
  {
    question: "É seguro discutir questões confidenciais online?",
    answer: "Sim, é totalmente seguro. Nosso escritório adota protocolos rígidos de segurança e confidencialidade, garantindo que todas as informações compartilhadas durante o atendimento online permaneçam protegidas. Utilizamos plataformas criptografadas para vídeo chamadas e troca de documentos, respeitando o sigilo profissional previsto no Estatuto da OAB. Além disso, todo o conteúdo do seu caso — documentos, contratos, comunicações e orientações jurídicas — é tratado com sigilo absoluto, da mesma forma como ocorreria em um atendimento presencial em nosso escritório em Recife. Dessa forma, você pode discutir seu caso com total tranquilidade, sem comprometer sua privacidade ou segurança."
  }
];

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div style={styles.faqItem}>
      <button onClick={() => setIsOpen(!isOpen)} style={styles.faqButton}>
        <span>{question}</span>
        <span style={styles.faqIcon}>{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && <div style={styles.faqAnswer}>{answer}</div>}
    </div>
  );
}

export default function Home() {
  return (
    <div style={styles.container}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        .whatsapp-float:hover { animation: pulse 1s infinite; }
        .btn-primary:hover { background: #16a34a !important; }
        .btn-secondary:hover { background: #d97706 !important; }
        .service-card:hover { border-color: #f59e0b !important; transform: translateY(-4px); }
        .faq-btn:hover { color: #f59e0b !important; }
      `}</style>

      {/* Floating WhatsApp Button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        style={styles.whatsappFloat}
      >
        <span style={styles.whatsappIcon}>💬</span>
      </a>

      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logo}>
            <img src="/logoescritorio.png" alt="Logo" style={{ height: "40px" }} />
            <div>
              <h1 style={styles.logoTitle}>Escritório Cavalcanti de Oliveira Advogados Associados</h1>
              <p style={styles.logoSubtitle}>Especialistas em Direito do Trabalho</p>
            </div>
          </div>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button className="btn-secondary" style={styles.headerBtn}>
              📞 Consulta 
            </button>
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section style={styles.hero}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroContent}>
          <span style={styles.badge}>⚖️ Atuação em todo Brasil</span>
          <h1 style={styles.heroTitle}>
            Advogado Trabalhista <span style={styles.highlight}>Especializado</span> em Garantir Seus Direitos
          </h1>
          <p style={styles.heroText}>
            Demissão sem justa causa, horas extras não pagas, verbas rescisórias ou assédio no trabalho? 
            Recupere o que é seu por direito com assessoria jurídica especializada.
          </p>
          <div style={styles.heroButtons}>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="btn-primary" style={styles.btnPrimary}>
                💬 Falar pelo WhatsApp
              </button>
            </a>
            <a href="#servicos" style={{ textDecoration: 'none' }}>
              <button style={styles.btnOutline}>
                Nossos Serviços →
              </button>
            </a>
          </div>

          {/* Differentials */}
          <div style={styles.differentialsGrid}>
            {differentials.map((item, index) => (
              <div key={index} style={styles.differentialCard}>
                <span style={styles.differentialIcon}>{item.icon}</span>
                <h3 style={styles.differentialTitle}>{item.title}</h3>
                <p style={styles.differentialText}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Rating Section */}
      <section style={styles.ratingSection}>
        <div style={styles.ratingContent}>
          <span style={styles.stars}></span>
          <span style={styles.ratingText}>
            <strong></strong> 
          </span>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicos" style={styles.servicesSection}>
        <div style={styles.sectionHeader}>
          <span style={styles.badge}>Áreas de Atuação</span>
          <h2 style={styles.sectionTitle}>Como Podemos Ajudar Você</h2>
          <p style={styles.sectionText}>
            Escolha um dos serviços abaixo e entre em contato para uma avaliação do seu caso
          </p>
        </div>
        <div style={styles.servicesGrid}>
          {services.map((service, index) => (
            <div key={index} className="service-card" style={styles.serviceCard}>
              <span style={styles.serviceIcon}>{service.icon}</span>
              <h3 style={styles.serviceTitle}>{service.title}</h3>
              <p style={styles.serviceText}>{service.description}</p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.serviceLink}
              >
                Falar sobre este caso →
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* About Section */}
      <section style={styles.aboutSection}>
        <div style={styles.aboutGrid}>
          <div style={styles.aboutContent}>
            <span style={styles.badge}>Sobre o Escritório</span>
            <h2 style={styles.aboutTitle}>
              Experiência e Dedicação na Defesa dos Seus Direitos
            </h2>
            <p style={styles.aboutText}>
              Com ampla experiência em Direito Trabalhista, nossa equipe já auxiliou centenas de trabalhadores 
              na proteção e defesa de seus direitos. Oferecemos um acompanhamento completo, da análise inicial 
              até a solução definitiva do caso.
            </p>
            <p style={styles.aboutText}>
              Sabemos que por trás de cada processo existe uma história, uma família e uma necessidade real. 
              Por isso, nosso compromisso vai além do jurídico: ouvir, orientar e acompanhar cada cliente 
              com respeito, transparência e total dedicação.
            </p>
            <div style={styles.statsGrid}>
              <div style={styles.statCard}>
                <span style={styles.statNumber}>1000+</span>
                <span style={styles.statLabel}>Casos resolvidos</span>
              </div>
              <div style={styles.statCard}>
                <span style={styles.statNumber}>26</span>
                <span style={styles.statLabel}>Anos de advocacia</span>
              </div>
            </div>
          </div>
          <div style={styles.aboutImageContainer}>
            <img
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692cb134b47ee8587c6fefcd/1794c559d_painhoblazer1.jpg"
              alt="Advogado Trabalhista"
              style={styles.aboutImage}
            />
            <div style={styles.aboutBadge}>
              <span>🏆</span>
              <div>
                <strong>Atendimento Humanizado</strong>
                <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>Compromisso com você</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={styles.ctaSection}>
        <div style={styles.ctaContent}>
          <h2 style={styles.ctaTitle}>Tem Dúvidas Sobre Seus Direitos?</h2>
          <p style={styles.ctaText}>
            Faça uma avaliação do seu caso. Responda algumas perguntas e nossa equipe irá analisar sua situação.
          </p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button className="btn-primary" style={styles.btnPrimary}>
              💬 Iniciar Conversa no WhatsApp
            </button>
          </a>
          <div style={styles.ctaFeatures}>
            <span>✅ Consulta 100% online ou presencial</span>
            <span>✅ Resposta em até 24h</span>
            <span>✅ Sem compromisso</span>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={styles.faqSection}>
        <div style={styles.sectionHeader}>
          <span style={styles.badge}>Dúvidas Frequentes</span>
          <h2 style={styles.sectionTitle}>Perguntas Frequentes</h2>
        </div>
        <div style={styles.faqContainer}>
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <div style={styles.logo}>
             <img src="/logoescritorio.png" alt="Logo" style={{ height: "40px" }} />
            <div>
              <h3 style={styles.logoTitle}>Escritório Cavalcanti de Oliveira Advogados Associados</h3>
              <p style={styles.logoSubtitle}>Especialistas em Direito do Trabalho</p>
            </div>
          </div>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" style={styles.footerContact}>
            💬 (81) 97916-3230
          <br />
            📧 cavalcantideoliveira@outlook.com
          
          </a>
        </div>
        <div style={styles.footerBottom}>
          
         

          <p>© {new Date().getFullYear()} Escritório Cavalcanti de Oliveira Advogados Associados. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(to bottom, #0f172a, #1e293b, #0f172a)',
    color: '#ffffff',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  whatsappFloat: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 50,
    background: '#22c55e',
    padding: '16px',
    borderRadius: '50%',
    boxShadow: '0 10px 40px rgba(34, 197, 94, 0.4)',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  whatsappIcon: {
    fontSize: '28px',
  },
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 40,
    background: 'rgba(15, 23, 42, 0.9)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(51, 65, 85, 0.5)',
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoIcon: {
    fontSize: '32px',
  },
  logoTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: 0,
  },
  logoSubtitle: {
    fontSize: '12px',
    color: '#9ca3af',
    margin: 0,
  },
  headerBtn: {
    background: '#f59e0b',
    color: '#0f172a',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '14px',
  },
  hero: {
    position: 'relative',
    paddingTop: '140px',
    paddingBottom: '80px',
    paddingLeft: '20px',
    paddingRight: '20px',
    backgroundImage: 'url("/painhoblazer1.jpg")',

    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  heroOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.9), rgba(15, 23, 42, 0.95))',
  },
  heroContent: {
    position: 'relative',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  badge: {
    display: 'inline-block',
    background: 'rgba(245, 158, 11, 0.2)',
    color: '#fbbf24',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    marginBottom: '24px',
    border: '1px solid rgba(245, 158, 11, 0.3)',
  },
  heroTitle: {
    fontSize: 'clamp(28px, 5vw, 52px)',
    fontWeight: 'bold',
    lineHeight: 1.2,
    marginBottom: '24px',
  },
  highlight: {
    color: '#f59e0b',
  },
  heroText: {
    fontSize: '18px',
    color: '#9ca3af',
    maxWidth: '700px',
    margin: '0 auto 32px',
    lineHeight: 1.7,
  },
  heroButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    justifyContent: 'center',
    marginBottom: '48px',
  },
  btnPrimary: {
    background: '#22c55e',
    color: '#ffffff',
    border: 'none',
    padding: '14px 32px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  btnOutline: {
    background: 'transparent',
    color: '#ffffff',
    border: '1px solid #475569',
    padding: '14px 32px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '16px',
  },
  differentialsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px',
  },
  differentialCard: {
    background: 'rgba(51, 65, 85, 0.5)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(71, 85, 105, 0.5)',
    borderRadius: '16px',
    padding: '20px',
    textAlign: 'center',
  },
  differentialIcon: {
    fontSize: '28px',
    display: 'block',
    marginBottom: '8px',
  },
  differentialTitle: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '4px',
  },
  differentialText: {
    fontSize: '12px',
    color: '#9ca3af',
    margin: 0,
  },
  ratingSection: {
    padding: '48px 20px',
    borderTop: '1px solid rgba(51, 65, 85, 0.5)',
    borderBottom: '1px solid rgba(51, 65, 85, 0.5)',
    background: 'rgba(30, 41, 59, 0.5)',
  },
  ratingContent: {
    maxWidth: '600px',
    margin: '0 auto',
    textAlign: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },
  stars: {
    fontSize: '24px',
  },
  ratingText: {
    fontSize: '18px',
    color: '#9ca3af',
  },
  servicesSection: {
    padding: '80px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '48px',
  },
  sectionTitle: {
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  sectionText: {
    color: '#9ca3af',
    maxWidth: '600px',
    margin: '0 auto',
  },
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
  },
  serviceCard: {
    background: 'rgba(51, 65, 85, 0.5)',
    border: '1px solid rgba(71, 85, 105, 0.5)',
    borderRadius: '16px',
    padding: '24px',
    transition: 'all 0.3s ease',
  },
  serviceIcon: {
    fontSize: '40px',
    display: 'block',
    marginBottom: '16px',
  },
  serviceTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px',
  },
  serviceText: {
    fontSize: '14px',
    color: '#9ca3af',
    marginBottom: '16px',
    lineHeight: 1.6,
  },
  serviceLink: {
    color: '#f59e0b',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '500',
  },
  aboutSection: {
    padding: '80px 20px',
    background: 'rgba(30, 41, 59, 0.5)',
  },
  aboutGrid: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '48px',
    alignItems: 'center',
  },
  aboutContent: {},
  aboutTitle: {
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: 'bold',
    marginBottom: '24px',
  },
  aboutText: {
    color: '#9ca3af',
    lineHeight: 1.7,
    marginBottom: '16px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    marginTop: '32px',
  },
  statCard: {
    background: 'rgba(51, 65, 85, 0.5)',
    borderRadius: '16px',
    padding: '20px',
    border: '1px solid rgba(71, 85, 105, 0.5)',
  },
  statNumber: {
    display: 'block',
    fontSize: '32px',
    fontWeight: 'bold',
    color: '#f59e0b',
  },
  statLabel: {
    fontSize: '14px',
    color: '#9ca3af',
  },
  aboutImageContainer: {
    position: 'relative',
  },
  aboutImage: {
    width: '100%',
    maxWidth: '400px',
    borderRadius: '16px',
    objectFit: 'cover',
  },
  aboutBadge: {
    position: 'absolute',
    bottom: '-20px',
    left: '-20px',
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
  },
  ctaSection: {
    padding: '80px 20px',
  },
  ctaContent: {
    maxWidth: '800px',
    margin: '0 auto',
    background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2), rgba(217, 119, 6, 0.1))',
    border: '1px solid rgba(245, 158, 11, 0.3)',
    borderRadius: '24px',
    padding: '48px 32px',
    textAlign: 'center',
  },
  ctaTitle: {
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  ctaText: {
    color: '#9ca3af',
    fontSize: '18px',
    maxWidth: '600px',
    margin: '0 auto 32px',
  },
  ctaFeatures: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '24px',
    marginTop: '32px',
    fontSize: '14px',
    color: '#9ca3af',
  },
  faqSection: {
    padding: '80px 20px',
    background: 'rgba(30, 41, 59, 0.5)',
  },
  faqContainer: {
    maxWidth: '700px',
    margin: '0 auto',
    background: 'rgba(51, 65, 85, 0.5)',
    border: '1px solid rgba(71, 85, 105, 0.5)',
    borderRadius: '16px',
    padding: '24px 32px',
  },
  faqItem: {
    borderBottom: '1px solid rgba(71, 85, 105, 0.5)',
  },
  faqButton: {
    width: '100%',
    padding: '20px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'none',
    border: 'none',
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    textAlign: 'left',
  },
  faqIcon: {
    color: '#f59e0b',
    fontSize: '24px',
    fontWeight: 'bold',
  },
  faqAnswer: {
    paddingBottom: '20px',
    color: '#9ca3af',
    lineHeight: 1.6,
  },
  footer: {
    borderTop: '1px solid rgba(51, 65, 85, 0.5)',
    padding: '48px 20px 24px',
  },
  footerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
  },
  footerContact: {
    color: '#9ca3af',
    textDecoration: 'none',
    fontSize: '16px',
  },
  footerBottom: {
    maxWidth: '1200px',
    margin: '32px auto 0',
    paddingTop: '24px',
    borderTop: '1px solid rgba(51, 65, 85, 0.5)',
    textAlign: 'center',
    fontSize: '14px',
    color: '#64748b',
  },
};